module.exports = __webpack_public_path__ + "img/map_picker_icon_none.3b727bf6.svg";